import { useState } from 'react';
import { AccordionDetails, AccordionSummary } from '@mui/material';
import QRModal, { QRModalProps } from 'views/modals/QRModal';
import QRCode from 'components/QRCode';
import { Wrapper, StyledAccordion, Header, Arrow, Text, Code } from './CodeAccordion.styles';

interface CodeAccordionProps {
  code: string;
  isAlert?: boolean;
  title: string;
  text: string;
  qrCaption?: string;
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

const CodeAccordion = ({
  code,
  isAlert = false,
  title,
  text,
  qrCaption,
  isOpen,
  onClick,
  className,
}: CodeAccordionProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOnModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const qrModalProps: QRModalProps = {
    isOpen: isModalOpen,
    onClose: handleOnModalToggle,
    title: `${title} ${code}`,
    code,
    description: qrCaption || text,
  };

  return (
    <Wrapper alert={`${isAlert}`} className={className}>
      <StyledAccordion
        expanded={isOpen}
        onChange={onClick}
        TransitionProps={{ unmountOnExit: true }}
      >
        <AccordionSummary expandIcon={<Arrow />}>
          <Header variant="h6">{title}</Header>
          <Code variant="h4">{code}</Code>
        </AccordionSummary>

        <AccordionDetails>
          <Text variant="body2">{text}</Text>
          <QRCode code={code} isAlert={isAlert} onClick={handleOnModalToggle} />
        </AccordionDetails>

        <QRModal {...qrModalProps} />
      </StyledAccordion>
    </Wrapper>
  );
};

export default CodeAccordion;
